import { Injectable, signal, WritableSignal } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: 'root',
})
export class StockingService {
    public static dynId: WritableSignal<string | null> = signal(null);
    public static dynSystem: WritableSignal<string | null> = signal(null);

    constructor(
        private http: HttpClient
    ) { }

    private readonly _apiUrl = environment.apiUrl + 'stocking/';


    getAvailableKeys() {
        const dynId = StockingService.dynId()!;
        return this.http.get<{ availableKeys: string[] }>(this._apiUrl + `get_available_keys?dyn_id=${dynId}`,);
    }

    getUsedKeys() {
        const dynId = StockingService.dynId()!;
        return this.http.get<{ usedHooks: { unitNumber: string, compartment_no: number }[] }>(this._apiUrl + `get_used_hooks?dyn_id=${dynId}`,);
    }

    triggerHook(key: string) {
        const dynId = StockingService.dynId()!;
        return this.http.get<{ freeHooks: number[], dedicatedHook: number }>(this._apiUrl + `trigger_hook/${dynId}/${key}`,);
    }

    returnKey(body: { key: string, hook: number }) {
        return this.http.post<any>(this._apiUrl + `/return_key`, body);
    }

    getSystemByDinId(dynId: string) {
        return this.http.get<{ system: { location: string, name_lang: { de: string } } }>(this._apiUrl + `getSystemByDynId/${dynId}`,);
    }
}